/* import __COLOCATED_TEMPLATE__ from './vertical-collection-list.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

/**

 List component to be passed to the `select-all-checkbox-manager` in place of the default
 `select-all-checkbox-manager/list component`. It makes use of `vertical-collection` for the
 management of large lists of options.

## Usage
```example
@title Basic Usage
@description Using `vertical-collection-list` with the `select-all-checkbox-manager`
@controller-properties
{
  options: [
    { label: 'Matt', isSelected: false },
    { label: 'Wright', isSelected: true },
    { label: 'Rulz', isSelected: false }
  ]
}

@hbs
{{#select-all-checkbox-manager tagName="table"
                               options=options
                               listComponent=(component "select-all-checkbox-manager/vertical-collection-list"
                                 estimateHeight=30
                                 containerSelector=".my-list-container")
                               as |checkbox-manager|}}
  <thead>
    <tr>
      <th>
        {{checkbox-manager.selectAllCheckbox label="Select All"}}
      </th>
    </tr>
  </thead>

  {{#checkbox-manager.list tagName="tbody" class="my-list-container" as |row option|}}
    <tr>
      <td>
        {{row.checkbox label=option.label}}
      </td>
    </tr>
  {{/checkbox-manager.list}}
{{/select-all-checkbox-manager}}
```

For full parameter descriptions see [`vertical-collection`](https://github.com/html-next/vertical-collection) docs.

@param {String} [containerSelector] - Selector for the vertical collection scrollContainer. Defaults to the immediate parent of the collection if null.
@param {Boolean} [staticHeight=true] - Determines the rendering strategy for vertical collection. Indicates if the occluded items' heights will change or not. If true, the vertical-collection will assume that items' heights are always equal to estimateHeight;
@param {Number} [estimateHeight] - Required. Estimated height of an item to be rendered. Use best guess as this will be used to determine how many items are displayed virtually, before and after the vertical-collection viewport.
@param {Number} [bufferSize=20] - The amount of extra items to keep visible on either side of the viewport -- must be greater than 0.
*/
let VerticalCollectionList = (_dec = classNames('select-all-checkbox-manager__vertical-collection-list'), _dec(_class = class VerticalCollectionList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "containerSelector", null);
    _defineProperty(this, "estimateHeight", null);
    _defineProperty(this, "staticHeight", true);
    _defineProperty(this, "bufferSize", 20);
  }
}) || _class);
export { VerticalCollectionList as default };